// import React, { memo, useContext, useEffect, useState } from "react";


// import { logApi, MainSumApi } from "../../../../../../../api/Api";
// import { Box, Card, CardActions, CardHeader, Container, CssBaseline, Grid, IconButton, Paper, Stack, Typography, colors, useTheme } from '@mui/material';


// import { InverterContext } from '../../../../../../../context/InverterContext';
// import { AppThemeContext } from '../../../../../../../context/AppThemeContext';
// import backgroundImage from '../../../../../../../assets/img/bg/chart2.png';
// import { AuthenticationContext } from '../../../../../../../context/AuthenticationContext'

// import SettingsIcon from '@mui/icons-material/Settings';

// import AutorenewIcon from '@mui/icons-material/Autorenew';

// import SolarSvg2 from "../../../../../../../assets/svg/lastSolarSvg2";

// import { getDateTimeForDashboardTab1, getFromTo } from '../../../../../../../utils'

// import AppModal from "../../../../../../../components/AppModal";
// import InvverterFullSize from "../../../../../../../components/inverter/InvverterFullSize";
// import Load3Svg from "../../../../../../../assets/svg/Load3Svg";
// import LtSvg from "../../../../../../../assets/svg/LtSvg";




// function LtSvgImage() {
//     const { LoggedInUserInfo } = React.useContext(AuthenticationContext)

//     const { PrimaryColor } = useContext(AppThemeContext);

//     const { spacing, palette, shape: { borderRadius } } = useTheme();
//     const { getHYBRD_Info, HYBRD_DATA_POWER_Loading, HYBRD_DATA_INFO, getPostKwhHybridForDashboard, getHYBRD_Power, HYBRD_DATA_POWER, POST_KWH_HYBRID_DATA_DASHBOARD } = useContext(InverterContext);

//     const [logData, setLogData] = useState([]);
//     const [mainData, setMainData] = useState([]);
//     const [StartDate, setStartDate] = useState(getDateTimeForDashboardTab1().LastDay)
//     const [EndDate, setEndDate] = useState(getDateTimeForDashboardTab1().Today)

//     const [OpenMix, setOpenMix] = useState(false);
//     const handleOpenMix = () => setOpenMix(true);
//     const handleCloseMix = () => setOpenMix(false);

//     const [credentials, setCredentials] = useState({
//         LOGIN_ID: sessionStorage.getItem("LoginID"),
//         LOC_CODE: sessionStorage.getItem("LCODE"),
//         PASS_KEY: sessionStorage.getItem("PASS_KEY") || "DEFAULT_PASS_KEY",
//         WEB_KEY: sessionStorage.getItem("WEB_KEY") || "DEFAULT_WEB_KEY",
//     });


//     const [sumCredentials, setSumCredentials] = useState({
//         LOGIN_ID: sessionStorage.getItem("LoginID") || "",
//         PASS_KEY: sessionStorage.getItem("KEY") || "xyz",
//         LCODE: sessionStorage.getItem("LCODE") || "",
//         DT1: StartDate,
//         DT2: EndDate,
//         TYP: "A",
//         WEB_KEY: "WEBXYZ321",
//         FID: "216HT001",
//     });



//     // this is fetching for MIDDLE data
//     const fetchLogData = async () => {
//         const res = await logApi(credentials);
//         if (res?.TOT_LIVE_KW_NEW && Array.isArray(res.TOT_LIVE_KW_NEW)) {
//             setLogData(res.TOT_LIVE_KW_NEW);
//         } else {
//             setLogData([]);
//         }
//     };

//     // useEffect(() => {
//     //     fetchLogData();
//     // }, [credentials]); // Fetch new data when credentials change


//     // this is fetching for MAIN_SUM
//     const fetchData = async () => {
//         const res = await MainSumApi(sumCredentials);
//         if (res?.KWH_MIS_MAIN_SUM && Array.isArray(res.KWH_MIS_MAIN_SUM)) {
//             setMainData(res.KWH_MIS_MAIN_SUM);
//         } else {
//             setMainData([]);
//         }
//     };

//     // useEffect(() => {
//     //     fetchData();
//     // }, [sumCredentials]); // Fetch new data when credentials change

//     // console.log("LoggedInUserInfo",LoggedInUserInfo)

//     useEffect(() => {
//         // Fetch data immediately on mount
//         fetchLogData();
//         fetchData();

//         // Set interval to fetch data every 30 seconds
//         const interval = setInterval(() => {
//             fetchLogData();
//             fetchData();
//         }, 30000); // 30 seconds in milliseconds

//         // Cleanup interval on unmount
//         return () => clearInterval(interval);
//     }, [credentials, sumCredentials]); // Dependencies to trigger re-setup if these values change



//     const blinkingAnimationDateTime = {
//         fontWeight: "900",
//         animation: 'blinkingAnimationDateTime 2s infinite',
//         transition: 'color 0.5s ease-in-out',
//     }
//     const blinkingAnimationBatteryStatusCharging = {
//         fontWeight: "900",
//         animation: 'blinkingAnimationDateTime 2s infinite',
//         transition: 'color 0.5s ease-in-out',
//         color: 'green'
//     }
//     const blinkingAnimationBatteryStatusDischarging = {
//         fontWeight: "900",
//         animation: 'blinkingAnimationDateTime 2s infinite',
//         transition: 'color 0.5s ease-in-out',
//         color: 'red'
//     }

//     const styles = {
//         IconStyle: {
//             color: 'primary.main',
//             fontSize: '1rem'
//         }
//     }

//     return (

//         <>


//             <Grid container style={{ padding: "0", margin: "0", height: "17rem" }}>
//                 {/* <Grid container style={{ padding: "0", margin: "0", height: "100%", minHeight: "600px" }}> */}




//                 {logData.map((log, indx) => (
//                     <Grid item xs={12} sm={12} md={12} lg={12} xl={12} padding={spacing(0)}>
//                         <Container sx={{ maxWidth: '100%', height: 'auto', position: 'relative' }}>


//                             <LtSvg svgColor={palette.primary.main} />

//                             <Typography variant='body2' sx={{ position: 'absolute', top: '8.5%', left: '11%', color: "black ! important" }} >
//                                 Solar
//                             </Typography>


//                             <Typography variant='body2' sx={{ position: 'absolute', top: '15.5%', left: '12%', color: "black ! important" }}  >
//                                 Grid
//                             </Typography>

//                             <Typography variant="body2" sx={{ position: "absolute", top: "2%", right: "20%", color: "black !important", fontSize: "1rem" }}>
//                                 ACDB Meter
//                             </Typography>

//                             <Typography variant='body2' sx={{ position: 'absolute', top: "8%", right: "21%", color: "#5CA904 ! important" }} className="blink" >
//                                 {log.SOLAR_MT !== undefined ? log.SOLAR_MT : "N/A"} kW
//                             </Typography>

//                             <Typography variant="body2" sx={{ position: "absolute", top: "2%", left: "43%", color: "black !important" }}>
//                                 Inverters
//                             </Typography>

//                             <Typography variant='body2' sx={{ position: 'absolute', top: "8%", left: "43%", color: "#5CA904 ! important" }} className="blink" >
//                                 {log.SOLAR !== undefined ? log.SOLAR : "N/A"} Kw
//                             </Typography>

//                             <Typography variant="body2" sx={{ position: "absolute", top: "10%", right: "20%", color: "black !important" }}>
//                                 Check Meter
//                             </Typography>

//                             <Typography variant='body2' sx={{ position: 'absolute', top: "15.5%", right: "23%", color: "#5CA904 ! important" }} className="blink" >
//                                 {log.CHECK_MT !== undefined ? log.CHECK_MT : "N/A"} Kw
//                             </Typography>

//                             <Typography variant="body2" sx={{ position: 'absolute', top: "10%", left: "43%", color: "black ! important" }}>
//                                 Main ABT
//                             </Typography>

//                             <Typography variant='body2' sx={{ position: 'absolute', top: "15.5%", left: "45%", color: "#5CA904 ! important" }} className="blink" >
//                                 {log.NET_MT !== undefined ? log.NET_MT : "N/A"} Kw
//                             </Typography>

//                             {/* <Typography variant='body2' sx={{ position: 'absolute', top: '10%', right: '25%' }}>
//                             {HYBRD_DATA_INFO?.INPUT_AC_ACTIVE_POWER} Kw Imp
//                         </Typography>

//                         <Typography variant='body2' sx={{ position: 'absolute', top: '20%', right: '25%' }}>
//                             {HYBRD_DATA_INFO?.['GRID POWER EXPORT']} Kw Exp
//                         </Typography> */}
//                             <Typography
//                                 variant="body2"
//                                 sx={{
//                                     position: "absolute",
//                                     top: "0%",
//                                     right: "4%",
//                                     color:
//                                         log.PLANT_STATUS?.toLowerCase() === "plant online"
//                                             ? "#5CA904 !important"
//                                             : log.PLANT_STATUS?.toLowerCase() === "plant offline"
//                                                 ? "red !important"
//                                                 : "inherit", // fallback if status is something else or undefined
//                                 }}
//                             >
//                                 <span style={{ fontSize: "1.3rem" }}>{log.PLANT_STATUS !== undefined ? log.PLANT_STATUS : "N/A"}</span>
//                             </Typography>


//                         </Container>
//                     </Grid>
//                 ))}


//             </Grid>



//         </>
//     );
// }


// export default memo(LtSvgImage)


import React, { memo, useContext, useEffect, useState } from "react";


import { logApi, MainSumApi } from "../../../../../../../api/Api";
import { Box, Card, CardActions, CardHeader, Container, CssBaseline, Grid, IconButton, Paper, Stack, Typography, colors, useTheme } from '@mui/material';


import { InverterContext } from '../../../../../../../context/InverterContext';
import { AppThemeContext } from '../../../../../../../context/AppThemeContext';
import backgroundImage from '../../../../../../../assets/img/bg/chart2.png';
import { AuthenticationContext } from '../../../../../../../context/AuthenticationContext'

import SettingsIcon from '@mui/icons-material/Settings';

import AutorenewIcon from '@mui/icons-material/Autorenew';

import SolarSvg2 from "../../../../../../../assets/svg/lastSolarSvg2";

import { getDateTimeForDashboardTab1, getFromTo } from '../../../../../../../utils'

import AppModal from "../../../../../../../components/AppModal";
import InvverterFullSize from "../../../../../../../components/inverter/InvverterFullSize";
import Load3Svg from "../../../../../../../assets/svg/Load3Svg";
import LtSvg from "../../../../../../../assets/svg/LtSvg";




function LtSvgImage() {
    const { LoggedInUserInfo } = React.useContext(AuthenticationContext)

    const { PrimaryColor } = useContext(AppThemeContext);

    const { spacing, palette, shape: { borderRadius } } = useTheme();
    const { getHYBRD_Info, HYBRD_DATA_POWER_Loading, HYBRD_DATA_INFO, getPostKwhHybridForDashboard, getHYBRD_Power, HYBRD_DATA_POWER, POST_KWH_HYBRID_DATA_DASHBOARD } = useContext(InverterContext);

    const [logData, setLogData] = useState([]);
    const [mainData, setMainData] = useState([]);
    const [StartDate, setStartDate] = useState(getDateTimeForDashboardTab1().LastDay)
    const [EndDate, setEndDate] = useState(getDateTimeForDashboardTab1().Today)

    const [OpenMix, setOpenMix] = useState(false);
    const handleOpenMix = () => setOpenMix(true);
    const handleCloseMix = () => setOpenMix(false);

    const [credentials, setCredentials] = useState({
        LOGIN_ID: sessionStorage.getItem("LoginID"),
        LOC_CODE: sessionStorage.getItem("LCODE"),
        PASS_KEY: sessionStorage.getItem("PASS_KEY") || "DEFAULT_PASS_KEY",
        WEB_KEY: sessionStorage.getItem("WEB_KEY") || "DEFAULT_WEB_KEY",
    });


    const [sumCredentials, setSumCredentials] = useState({
        LOGIN_ID: sessionStorage.getItem("LoginID") || "",
        PASS_KEY: sessionStorage.getItem("KEY") || "xyz",
        LCODE: sessionStorage.getItem("LCODE") || "",
        DT1: StartDate,
        DT2: EndDate,
        TYP: "A",
        WEB_KEY: "WEBXYZ321",
        FID: "216HT001",
    });



    // this is fetching for MIDDLE data
    const fetchLogData = async () => {
        const res = await logApi(credentials);
        if (res?.TOT_LIVE_KW_NEW && Array.isArray(res.TOT_LIVE_KW_NEW)) {
            setLogData(res.TOT_LIVE_KW_NEW);
        } else {
            setLogData([]);
        }
    };

    // useEffect(() => {
    //     fetchLogData();
    // }, [credentials]); // Fetch new data when credentials change


    // this is fetching for MAIN_SUM
    const fetchData = async () => {
        const res = await MainSumApi(sumCredentials);
        if (res?.KWH_MIS_MAIN_SUM && Array.isArray(res.KWH_MIS_MAIN_SUM)) {
            setMainData(res.KWH_MIS_MAIN_SUM);
        } else {
            setMainData([]);
        }
    };

    // useEffect(() => {
    //     fetchData();
    // }, [sumCredentials]); // Fetch new data when credentials change

    // console.log("LoggedInUserInfo",LoggedInUserInfo)

    useEffect(() => {
        // Fetch data immediately on mount
        fetchLogData();
        fetchData();

        // Set interval to fetch data every 30 seconds
        const interval = setInterval(() => {
            fetchLogData();
            fetchData();
        }, 60000); // 30 seconds in milliseconds

        // Cleanup interval on unmount
        return () => clearInterval(interval);
    }, [credentials, sumCredentials]); // Dependencies to trigger re-setup if these values change



    const blinkingAnimationDateTime = {
        fontWeight: "900",
        animation: 'blinkingAnimationDateTime 2s infinite',
        transition: 'color 0.5s ease-in-out',
    }
    const blinkingAnimationBatteryStatusCharging = {
        fontWeight: "900",
        animation: 'blinkingAnimationDateTime 2s infinite',
        transition: 'color 0.5s ease-in-out',
        color: 'green'
    }
    const blinkingAnimationBatteryStatusDischarging = {
        fontWeight: "900",
        animation: 'blinkingAnimationDateTime 2s infinite',
        transition: 'color 0.5s ease-in-out',
        color: 'red'
    }

    const styles = {
        IconStyle: {
            color: 'primary.main',
            fontSize: '1rem'
        }
    }

    return (

        <>


            <Grid
                container
                sx={{
                    padding: 0,
                    margin: 0,
                    height: {
                        xs: "10rem",   // 📱 मोबाइल स्क्रीन के लिए (कम height)
                        sm: "12rem",   // 📱 छोटे टैबलेट के लिए
                        md: "15rem",   // 💻 मीडियम स्क्रीन के लिए
                        lg: "17rem",   // 🖥️ डेस्कटॉप के लिए
                    },
                }}
            >

                {/* <Grid container style={{ padding: "0", margin: "0", height: "100%", minHeight: "600px" }}> */}




                {logData.map((log, indx) => (
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} padding={spacing(0)}>
                        <Container sx={{ maxWidth: '100%', height: 'auto', position: 'relative' }}>


                            <LtSvg svgColor={palette.primary.main} />

                            <Typography variant='body2' sx={{ position: 'absolute', top: '8.5%', left: '11%', color: "black ! important" }} >
                                Solar
                            </Typography>


                            <Typography variant='body2' sx={{ position: 'absolute', top: '15.5%', left: '12%', color: "black ! important" }}  >
                                Grid
                            </Typography>

                            <Typography variant="body2" sx={{ position: "absolute", top: "1%", right: "20%", color: "black !important", fontSize: "1rem" }}>
                                ACDB Meter
                            </Typography>

                            <Typography variant='body2' sx={{ position: 'absolute', top: "8%", right: "21%", color: "#5CA904 ! important" }} className="blink" >
                                {log.SOLAR_MT !== undefined ? log.SOLAR_MT : "N/A"} kW
                            </Typography>

                            <Typography variant="body2" sx={{ position: "absolute", top: "1%", left: "43%", color: "black !important" }}>
                                Inverters
                            </Typography>

                            <Typography variant='body2' sx={{ position: 'absolute', top: "8%", left: "43%", color: "#5CA904 ! important" }} className="blink" >
                                {log.SOLAR !== undefined ? log.SOLAR : "N/A"} kW
                            </Typography>

                            <Typography variant="body2" sx={{ position: "absolute", top: "9.5%", right: "20%", color: "black !important" }}>
                                Check Meter
                            </Typography>

                            <Typography variant='body2' sx={{ position: 'absolute', top: "15.5%", right: "23%", color: "#5CA904 ! important" }} className="blink" >
                                {log.CHECK_MT !== undefined ? log.CHECK_MT : "N/A"} kW
                            </Typography>

                            <Typography variant="body2" sx={{ position: 'absolute', top: "9.5%", left: "43%", color: "black ! important" }}>
                                Main ABT
                            </Typography>

                            <Typography variant='body2' sx={{ position: 'absolute', top: "15.5%", left: "45%", color: "#5CA904 ! important" }} className="blink" >
                                {log.NET_MT !== undefined ? log.NET_MT : "N/A"} kW
                            </Typography>

                            {/* <Typography variant='body2' sx={{ position: 'absolute', top: '10%', right: '25%' }}>
                            {HYBRD_DATA_INFO?.INPUT_AC_ACTIVE_POWER} Kw Imp
                        </Typography>

                        <Typography variant='body2' sx={{ position: 'absolute', top: '20%', right: '25%' }}>
                            {HYBRD_DATA_INFO?.['GRID POWER EXPORT']} Kw Exp
                        </Typography> */}
                            <Typography
                                variant="body2"
                                sx={{
                                    position: "absolute",
                                    top: "-.5%",
                                    left: "4%",
                                    color:
                                        log.PLANT_STATUS?.toLowerCase() === "plant online"
                                            ? "#5CA904 !important"
                                            : log.PLANT_STATUS?.toLowerCase() === "plant offline"
                                                ? "red !important"
                                                : "inherit", // fallback if status is something else or undefined
                                }}
                            >
                                <span style={{ fontSize: "1.3rem" }}>{log.PLANT_STATUS !== undefined ? log.PLANT_STATUS : "N/A"}</span>
                            </Typography>


                        </Container>
                    </Grid>
                ))}


            </Grid>



        </>
    );
}


export default memo(LtSvgImage)


